import React from 'react';
import PropTypes from 'prop-types';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import FalconComponentCard from 'components/common/FalconComponentCard';
import corner6 from 'assets/img/illustrations/corner-6.png';
import { buildRepositoryNotaryJournalColumns } from './repositoryNotaryJournalColumns';
import OrganizationBillingSetupNotice from './OrganizationBillingSetupNotice';

const placeholderCells = {
  SigningTimestamp: 'Hidden date and time',
  NotaryEntries: 'Shared documents',
  NotaryFee: 'Hidden fee',
  State: 'Hidden address',
  none: '...'
};

const columns = buildRepositoryNotaryJournalColumns({
  onRowClicked: () => {}
}).map(column =>
  placeholderCells[column.accessor]
    ? {
        ...column,
        Cell: () => <span>{placeholderCells[column.accessor]}</span>
      }
    : column
);

// Match the journal table's appearance without loading locked journal contents.
const previewRows = Array.from({ length: 5 }, (_, index) => ({
  GUID: `locked-preview-${index}`,
  Signers: ['Shared journal signer']
}));

const OrganizationBillingLockedJournals = ({ canManage }) => (
  <>
    <OrganizationBillingSetupNotice canManage={canManage} />
    <AdvanceTableWrapper
      columns={columns}
      data={previewRows}
      selection={false}
      sortable={false}
      sortBy={[]}
    >
      <FalconComponentCard noGuttersBottom>
        <FalconComponentCard.Header
          image={corner6}
          className="px-4"
          title="Journal entries"
          subtitle="Browse notary journal entries for this user"
        />
        <div className="py-0 px-4">
          <p className="visually-hidden">
            Locked journal preview. Journal details cannot be viewed or
            reviewed.
          </p>
          <div aria-hidden="true">
            <AdvanceTable
              table
              headerClassName="bg-200 text-900 text-nowrap align-middle"
              rowClassName="align-middle white-space-nowrap block-text-blur"
              tableProps={{
                size: 'sm',
                striped: true,
                className: 'fs--1 mb-0 overflow-hidden'
              }}
            />
          </div>
        </div>
      </FalconComponentCard>
    </AdvanceTableWrapper>
  </>
);

OrganizationBillingLockedJournals.propTypes = { canManage: PropTypes.bool };

export default OrganizationBillingLockedJournals;
